// src/hooks/useDiscogsForm.js
import { useState, useEffect } from "react";
import { parseDiscogsData } from "../utils/parseDiscogsData";
import { generateDescription } from "../utils/generateDescription";
import { getFinalFeatures } from "../utils/ebayUtils";

export function useDiscogsForm() {
  const [formData, setFormData] = useState({
    title: "",
    artist: "",
    label: "",
    catalogNumber: "",
    releaseYear: "",
    format: "",
    genre: "",
    style: "",
    color: "",
    features: "",
    edition: "",
    recordSize: "",
    speed: "",
    conditionMedia: "",
    conditionSleeve: "",
    conditionInlay: "",
    itemCondition: "USED",
  });

  const [discogsRelease, setDiscogsRelease] = useState(null);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      conditionMedia: "Near Mint (NM or M-)",
      conditionSleeve: "Near Mint (NM or M-)",
      conditionInlay: "Near Mint (NM or M-)",
    }));
  }, []);

  const handleDiscogsData = (release) => {
    setDiscogsRelease(release);
    const parsed = parseDiscogsData(release, formData.itemCondition || "USED");

    setFormData((prev) => {
      const updated = {
        ...prev,
        ...parsed,
        description: generateDescription({
          ...prev,
          ...parsed,
          itemCondition: prev.itemCondition || "USED",
          series: release.series || [], // ✅ add this line
        }),
      };
      return updated;
    });
  };

  const handleItemConditionChange = (value) => {
    const [media, sleeve, inlay] =
      value === "NEW"
        ? ["Mint (M)", "Mint (M)", "Mint (M)"]
        : [
            "Near Mint (NM or M-)",
            "Near Mint (NM or M-)",
            "Near Mint (NM or M-)",
          ];

    setFormData((prev) => {
      const updatedFeatures = getFinalFeatures(prev.features, value); // value = "NEW" or "USED"

      let updated = {
        ...prev,
        itemCondition: value,
        conditionMedia: media,
        conditionSleeve: sleeve,
        conditionInlay: inlay,
        features: updatedFeatures,
      };


      return {
        ...updated,
        description: generateDescription({
          ...updated,
          series: discogsRelease?.series || [], // ✅ use current release
        }),
      };
    });
  };

  return {
    formData,
    setFormData,
    discogsRelease,
    handleDiscogsData,
    handleItemConditionChange,
  };
}
